<template>
  <div class="route-input">
    <div class="main-title">
      <span> <i class="el-icon-folder-opened"></i> 线路录入 </span>
    </div>
    <div class="input-table">
      <table class="input-form" v-loading="loading">
        <thead>
          <tr>
            <th colspan="4">线路录入</th>
          </tr>
          <tr>
            <td>线路名称</td>
            <td>
              <el-input
                v-model="form.Name"
                placeholder="请输入线路名称"
              ></el-input>
            </td>
            <td>线路描述</td>
            <td>
              <el-input
                v-model="form.Describe"
                placeholder="请输入线路描述"
              ></el-input>
            </td>
          </tr>
          <tr>
            <td>餐厅名称</td>
            <td>
              <el-input
                v-model="form.RestaurantName"
                placeholder="请输入餐厅名称"
              ></el-input>
            </td>
            <td>餐饮价格（元）</td>
            <td>
              <el-input-number
                v-model="form.RestaurantPrice"
                :precision="2"
                :min="0"
              ></el-input-number>
            </td>
          </tr>
          <tr>
            <td>成人价格（元）</td>
            <td>
              <el-input-number
                v-model="form.AdultPrice"
                :precision="2"
                :min="0"
              ></el-input-number>
            </td>
            <td>儿童价格（元）</td>
            <td>
              <el-input-number
                v-model="form.ChildrenPrice"
                :precision="2"
                :min="0"
              ></el-input-number>
            </td>
          </tr>
          <tr>
            <td>老年人价格（元）</td>
            <td>
              <el-input-number
                v-model="form.ElderlyPrice"
                :precision="2"
                :min="0"
              ></el-input-number>
            </td>
            <td>产品编号</td>
            <td>
              <el-input
                  v-model="form.ProductNumber"
                  placeholder="请输入产品编号"
              ></el-input>
            </td>
          </tr>
          <div class="subtable-tab">
            <div
              v-for="(item, index) in table.subtable"
              :key="index"
              class="mouse-pointer tab-item"
              :class="{ 'sub-selected': table.currentSubId === item.id }"
              @click="handleSubtable('switch', item.id)"
            >
              <div>第{{ item.id + 1 }}天</div>
            </div>
            <div class="subtable-handle">
              <el-button-group>
                <el-button type="plain" @click="handleSubtable('plus')"
                  >＋</el-button
                >
                <el-button type="plain" @click="handleSubtable('minus')"
                  >﹣</el-button
                >
              </el-button-group>
            </div>
          </div>
          <tr style="height: 45px"></tr>
        </thead>
        <tbody>
          <tr>
            <td>行程项目</td>
            <td colspan="2">行程时间</td>
            <td>行程类型</td>
          </tr>
          <tr
            v-for="(item, index) in table.subtable[table.currentSubId]
              .arrangement"
            :key="index + 1"
          >
            <td>
              <el-select v-model="item.proId" placeholder="请选择" filterable>
                <el-option
                  v-for="pro in options.projects"
                  :key="pro.Id"
                  :label="pro.ProjectName"
                  :value="pro.Id"
                ></el-option>
              </el-select>
            </td>
            <td colspan="2">
              <el-time-picker
                is-range
                :clearable="false"
                format="HH:mm"
                value-format="HH:mm"
                v-model="item.time"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围"
              >
              </el-time-picker>
            </td>
            <td>{{ item.proId | getProjectType(options.projects) }}</td>
          </tr>
          <tr>
            <td colspan="4">
              <el-button-group>
                <el-button
                  type="primary"
                  size="mini"
                  @click="handleArrangement('plus')"
                  >继续添加</el-button
                >
                <el-button
                  type="danger"
                  size="mini"
                  @click="handleArrangement('minus')"
                  >删除行</el-button
                >
              </el-button-group>
            </td>
          </tr>
        </tbody>
      </table>

      <div style="text-align: center; padding-top: 40px">
        <el-button type="success" size="medium" @click="submit('form')"
          >保存</el-button
        >
        <el-button type="primary" size="medium" @click="reset">重置</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import ValidationProvider from "@/common/vee-validator";
import { ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import ROUTE from "@/api/route";
// import SCENIC from "@/api/scenic";
export default {
  name: "OrderInput",
  data() {
    return {
      loading: false,

      config: {
        Name: "线路名称",
        RestaurantPrice: "餐饮价格",
        AdultPrice: "成人价格",
        ChildrenPrice: "儿童价格",
        ElderlyPrice: "老年人价格",
      },

      form: {
        RestaurantName: "", //餐厅名称
        RestaurantPrice: 0, //餐饮价格
        AdultPrice: 0, //成人价格
        ChildrenPrice: 0, //儿童价格
        ElderlyPrice: 0, //老年人价格
        Name: "", //线路名
        Describe: "", //线路描述
        ProductNumber:"",//产品编号
        lstLineDetails: [
          // {
          //   //行程安排单天
          //  DayLineDetails:[
          //    //单天具体项目
          //    {PointId:'',StartTime:'',EndTime:'',DayIndex:1,Projects}
          //    ]
          // }
        ], //游客信息表
      },
      timerIndex: 1,
      table: {
        currentSubId: 0,
        subtable: [
          {
            id: 0,
            arrangement: [
              {
                proId: "",
                time: ["08:00", "09:00"],
                type: "",
              },
            ],
          },
        ],
      },

      linePointFlag: {
        flag: false,
        day: 0,
        point: 0,
      },
    };
  },
  watch: {
    table: {
      deep: true,
      handler: function (newVal, oldVal) {
        let _self = this;
        let temp = "";
        _self.linePointFlag = {
          flag: false,
          day: 0,
          point: 0,
        };
        newVal.subtable.forEach((i, index) => {
          i.arrangement.forEach((c, count) => {
            if (count == 0) {
              temp = _self.getStr(c.time[0].trim());
            }

            var vv = _self.getStr(c.time[0].trim());
            if (temp <= vv) temp = vv;
            else {
              _self.linePointFlag = {
                flag: true,
                day: index + 1,
                point: count + 1,
              };
              return;
            }

            var vvv = _self.getStr(c.time[1].trim());
            if (temp <= vvv) temp = vvv;
            else {
              _self.linePointFlag = {
                flag: true,
                day: index + 1,
                point: count + 1,
              };
              return;
            }
          });
        });
      },
    },
  },
  methods: {
    getStr(str) {
      var aa = "";
      var bb = "";
      if (str.length == 4) {
        //8:00
        aa = str.substring(0, 1);
        bb = str.substring(str.length, 2);
      } else {
        //10:00
        aa = str.substring(0, 2);
        bb = str.substring(str.length - 2);
      }
      return aa + bb;
    },
    getProjectName(id) {
      for (const pro of this.options.projects) {
        if (pro.Id == id) {
          return pro.ProjectName;
        }
      }
      return "";
    },
    //保存
    submit(formName) {
      var _self = this;
      if (_self.linePointFlag.flag) {
        _self.$message.error(
          "第" +
            _self.linePointFlag.day +
            "天的第" +
            _self.linePointFlag.point +
            "个景点时间范围错误请修改"
        );
        return;
      }

      for (var key in _self.form) {
        if (
          (_self.form[key] == undefined || _self.form[key].toString().trim().length == 0) &&
          _self.config[key] != undefined
        ) {
          _self.$message.error(_self.config[key] + '未填写');
          return
        }
      }

      _self.form.lstLineDetails = []; //解决添加失败后脏数据的问题
        _self.table.subtable.forEach((v) => {
          let obj = { DayLineDetails: [] };
          v.arrangement.forEach((a) => {
            obj.DayLineDetails.push({
              PointId: a.proId,
              StartTime: a.time[0],
              EndTime: a.time[1],
              DayIndex: v.id + 1,
              Projects: _self.getProjectName(a.proId),
            });
          });
          _self.form.lstLineDetails.push(obj);
        });

        ROUTE.addRoute(_self.form).then((res) => {
          if (res.status === "success") {
            //准备参数
            _self.loading = true;
            _self.$message.success("添加成功!");
            //更新仓库路线信息
            _self.$store.dispatch("trip/setRoutes");
            _self.reset(); //清空数据
          } else {
            _self.$message.error(res.msg);
          }
          _self.loading = false;
        });


      // _self.$refs[formName].validate().then((success) => {
      // })
    },
    //重置
    reset() {
      this.linePointFlag = {
        flag: false,
        day: 0,
        point: 0,
      };
      this.form = {
        Name: "", //线路名
        Describe: "", //线路描述
        RestaurantName: "", //餐厅名称
        RestaurantPrice: 0, //餐饮价格
        AdultPrice: 0, //成人价格
        ChildrenPrice: 0, //儿童价格
        ElderlyPrice: 0, //老年人价格
        lstLineDetails: [],
      };
      this.table = {
        currentSubId: 0,
        subtable: [
          {
            id: 0,
            arrangement: [
              {
                proId: "",
                time: ["08:00", "09:00"],
                // StartTime:'',
                // EndTime:'',
                type: "",
              },
            ],
          },
        ],
      };
    },

    //子表操作
    handleSubtable(type, subId) {
      switch (type) {
        case "plus":
          this.table.currentSubId = this.table.subtable.length;
          this.table.subtable.push({
            id: this.table.subtable.length,
            arrangement: [
              {
                proId: "",
                time: ["08:00", "09:00"],
                // StartTime:'',
                // EndTime:'',
                type: "",
              },
            ],
          });

          break;
        case "minus":
          if (this.table.subtable.length > 1) {
            // this.table.subtable.pop()
            let index = 0;
            this.table.subtable.forEach((item, i) => {
              if (item.id == this.table.currentSubId) {
                index = i;
                this.table.subtable.splice(i, 1);
              }
            });
            this.table.subtable.forEach((item, i) => {
              item.id = i;
            });
            if (index > 0)
              this.table.currentSubId = this.table.subtable[index - 1].id;
            else this.table.currentSubId = this.table.subtable[index].id;
          } else {
            this.$message.error("至少录入一天行程!");
          }
          break;
        case "switch":
          this.table.currentSubId = subId;
          break;
        default:
          break;
      }
    },
    //行程安排操作
    handleArrangement(type) {
      var _self = this;
      if (type === "plus") {
        if (_self.linePointFlag.flag) {
          _self.$message.error(
            "第" +
              _self.linePointFlag.day +
              "天的第" +
              _self.linePointFlag.point +
              "个景点时间范围错误请修改"
          );
          return;
        }

        if (
          _self.table.subtable[_self.table.currentSubId].arrangement[
            _self.table.subtable[_self.table.currentSubId].arrangement.length -
              1
          ].time[1] == "23:59"
        ) {
          _self.$message.error("当天行程已满无法继续添加!");
          return;
        }
        if (_self.timerIndex >= 1)
          _self.startTime =
            _self.table.subtable[_self.table.currentSubId].arrangement[
              _self.table.subtable[_self.table.currentSubId].arrangement
                .length - 1
            ].time[1];
        this.timerIndex++;

        // if(_self.table.subtable[_self.table.currentSubId].arrangement[
        //   _self.table.subtable[_self.table.currentSubId].arrangement.length-1
        // ].EndTime=="23:59")
        // {
        //   _self.$message.error('当天行程已满无法继续添加!')
        //   return;
        // }

        // if (_self.timerIndex >= 1){
        //   _self.startTime = _self.table.subtable[_self.table.currentSubId].
        //   arrangement[_self.table.subtable[_self.table.currentSubId].arrangement.length - 1].EndTime;
        // }

        // _self.timerIndex++;
        let endTime =
          parseInt(_self.startTime.substring(0, 2)) + 1 >= 24
            ? "23:59"
            : parseInt(_self.startTime.substring(0, 2)) + 1 >= 10
            ? parseInt(_self.startTime.substring(0, 2)) + 1 + ":00"
            : "0" + (parseInt(_self.startTime.substring(0, 2)) + 1) + ":00";
        _self.table.subtable[_self.table.currentSubId].arrangement.push({
          proId: "",
          time: [this.startTime, endTime],
          // StartTime: _self.startTime,
          // EndTime: '',
          type: "",
        });
      } else if (type === "minus") {
        if (
          _self.table.subtable[_self.table.currentSubId].arrangement.length > 1
        ) {
          _self.timerIndex--;

          _self.startTime =
            _self.table.subtable[_self.table.currentSubId].arrangement[
              _self.table.subtable[_self.table.currentSubId].arrangement
                .length - 1
            ].time[1];

          // _self.startTime = _self.table.subtable[_self.table.currentSubId].arrangement[
          //   _self.table.subtable[_self.table.currentSubId].arrangement.length - 1
          // ].EndTime;

          _self.table.subtable[_self.table.currentSubId].arrangement.pop();
        } else {
          _self.$message.error("至少录入一条行程!");
        }
      }
    },
  },
  created() {},
  mounted() {
    let _self = this;
  },
  computed: {
    ...mapState("trip", {
      options: (state) => {
        return { projects: state.projects };
      },
    }),
  },
  filters: {
    getProjectType(value, projects) {
      for (const pro of projects) {
        if (pro.Id == value) {
          return pro.Type;
        }
      }
      return "";
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
};
</script>

<style scoped lang="less">
.main-title {
  width: 100%;
  justify-content: space-between;
  padding: 5px 10px;
  align-items: center;
  background: #efefef;
}
.input-table {
  padding: 20px;
}
.input-form {
  position: relative;

  width: 95%;
  border-collapse: collapse;
  border: 1px solid #aaa;
  thead {
    // width: 100%;
    background-color: #f1f1f1;
    border: 1px solid #aaa;
  }
  th,
  tr {
    height: 33px;
    overflow: hidden;
    border: 1px solid #aaa;
  }
  td,
  th {
    text-align: center;
    vertical-align: middle;
    border: 1px solid #aaa;
  }
}
.input-form /deep/ .el-input__inner,
.input-form /deep/ .el-input-number,
.input-form /deep/ .el-select {
  border: none;
  width: 100%;
}
.sub-selected {
  background: cornflowerblue;
}
.subtable-tab {
  position: absolute;
  top: 197px;
  left: 0;
  width: 100%;
  height: 45px;
  overflow: auto hidden;
  border-left: 1px solid #aaa;
  border-right: 1px solid #aaa;
  display: flex;
  // background: red;
}
.subtable-tab .tab-item {
  border-right: 1px solid #aaa;
  min-width: 60px;
  height: 45px;
  line-height: 45px;
  text-align: center;
}
.subtable-tab .subtable-handle {
  min-width: 100px;
  border-right: 1px solid #aaa;
}
.subtable-tab /deep/ .el-button-group > .el-button {
  width: 50px;
  height: 45px;
  padding: 0;
  font-size: 18px;
  // border: none;
}
</style>
